import React, { useState } from "react";
import { Select, MenuItem, InputAdornment, IconButton, Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const CustomDropdown = ({ hint, passwordMode, startIcon, onChange, options, error, textValue }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState("");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (event) => {
    setValue(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        maxWidth: "400px",
        height: "55px",
      }}
    >
      <Select
        variant="standard"
        value={value || textValue}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={handleChange}
        style={{
          width: "100%",
          backgroundColor: "#1F222A",
          borderRadius: "10px",
          paddingLeft: startIcon ? "55px" : "10px", // Ajuste de padding para el icono
          height: "55px",
          border: "none",
          outline: "none",
          color: "rgba(255, 255, 255, 1)", // Color del texto en el Select
          fontSize: "18px",
        }}
        displayEmpty
        inputProps={{
          style: {
            fontSize: "18px",
            fontFamily: "Urbanist",
            fontWeight: "regular",
            color: "rgba(255, 255, 255, 1)", // Color del texto en el Select
            padding: "10px 20px",
            minHeight: "45px",
            border: "none",
            outline: "none",
          },
        }}
        MenuProps={{
          PaperProps: {
            style: {
              backgroundColor: "#1F222A", // Cambia el color de fondo aquí
            },
          },
        }}
        sx={{
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
          },
          "& .MuiSelect-icon": {
            color: !focused ? "rgba(255, 255, 255, 0.5)" : "#FF6401",
            paddingRight: "10px",
          },
          "&:focus-within": {
            boxShadow: "0 0 0 2px #FF6401", // Sombra cuando el dropdown está en foco
            border: "2px solid #FF6401", // Borde cuando el dropdown está en foco
          },
          "&:before, &:after": {
            display: "none", // Eliminar la línea debajo del dropdown
          },
        }}
      >
        <MenuItem disabled value="">
          <Typography
            style={{
              fontSize: "18px",
              fontFamily: "Urbanist",
              fontWeight: "regular",
              color: "rgba(255, 255, 255, 0.5)", // Color del texto del hint
            }}
          >
            {hint}
          </Typography>
        </MenuItem>
        {options.map((option) => (
          <MenuItem
            key={option}
            value={option}
            style={{
              backgroundColor: "#1F222A", // Asegura que el fondo sea el mismo que el del Select
              color: "rgba(255, 255, 255, 1)", // Color del texto del MenuItem
              fontSize: "18px",
              fontFamily: "Urbanist",
              fontWeight: "regular",
            }}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
      {startIcon &&
        React.cloneElement(startIcon, {
          style: {
            color: focused ? "#FF6401" : error ? "#FF1F01" : "rgba(255, 255, 255, 0.5)",
            position: "absolute",
            top: "14px",
            left: "20px",
          },
        })}
    </div>
  );
};

export default CustomDropdown;
